// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd u-pr++\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"::{'is-negative-charge' : row.entity.isInvoiceBalanceNegative}\" ng-bind=\"::row.entity.invoiceBalance | invEmpty\">\n    </div>\n</div>\n";
// Exports
module.exports = code;